import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { UserInfo } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'login',
    events: {
        'Login Start': props<{ email: string; resend: boolean }>(),
        'Login Start Success': emptyProps(),
        'Login Start Failure': props<{ error: string }>(),

        'OAuth Token': props<{ email: string; code: string }>(),
        'OAuth Token Success': props<{ token: string; redirect?: boolean }>(),
        'OAuth Token Failure': props<{ error: string }>(),

        'Try Redirect To Partner Web': emptyProps(),

        Logout: emptyProps(),
        'Logout Success': emptyProps(),

        'Init Hygraph Form': props<{ name: string }>(),

        'Get Form Id': props<{ name: string }>(),
        'Get Form Id Success': props<{ formId: string }>(),
        'Get Form Id Failure': props<{ error: string }>(),

        'Load User Info': emptyProps(),
        'Load User Info Success': props<{ userInfo: UserInfo }>(),
        'Load User Info Failure': props<{ error: string }>(),

        'Get Jwt From Partner Web': emptyProps(),
        'Get Jwt From Partner Web Success': props<{ jwt: string }>(),
        'Get Jwt From Partner Web Failure': props<{ error: string }>(),
    },
});
